module.exports = __webpack_public_path__ + "img/switch9.85c69596.png";